import { render, staticRenderFns } from "./ModalDuplicationMenu.vue?vue&type=template&id=41118dd5&"
import script from "./ModalDuplicationMenu.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports